<template>
    <div class="pricing-display-container">
         <div class="mb-2">
           <div class="swithTitle"> 
                   {{ $t('lbl_EMPBE_PricingDisplay') }}&nbsp;&nbsp;<span class="NewsTips">{{$t("lbl_EMPBE_HighlyRecommended") }}                    
                   </span>
            </div>
         </div>

        <switchIput  v-model="formData.ProductPriceDisplay"
            style="margin-bottom: 0px !important;"></switchIput>
        <div v-if="formData.ProductPriceDisplay">
            <label class="price" v-if="!formData.ProductPriceRange">

                {{ this.currencyUnit }} {{ formData.ProductPriceAmount }} / {{ formData.ProductPriceItemUnit != "99" ?
                    this.unit : formData.ProductPriceItemUnitOther }}
            </label>
            <label class="price" v-if="formData.ProductPriceRange">
                {{ this.currencyUnit }} {{ formData.ProductPriceAmount }} - {{ formData.ProductPriceAmountMax }} / {{
                    formData.ProductPriceItemUnit != "99" ? this.unit : formData.ProductPriceItemUnitOther }}
            </label>

            <div class="price-container">
                <div class="flex-container">
                    <div class="flex-item">
                        <selection id="Currency" :title="this.$t('lbl_EMPBE_Currency')" :options="this.optionsCurrency"
                            v-model="formData.ProductPriceCurrUnit" :clearable="true"
                            style="margin-bottom: 0px !important;">
                        </selection>
                    </div>
                    <div class="flex-item" style="margin-bottom: 0px !important;" v-if="!formData.ProductPriceRange">
                        <textbox id="SellingPrice" :title="this.$t('lbl_EMPBE_SellingPrice')"
                            :placeholder="this.$t('lbl_EMPBE_FillPriceHere')" type="number" LimitDecimals="2"
                            :rules="{greater_than_0 : true}"
                            v-model="formData.ProductPriceAmount" style="margin-bottom: 0px !important;" />
                    </div>
                    <div class="flex-item" v-if="formData.ProductPriceRange">
                        <textbox id="minPrice" :title="this.$t('lbl_EMPBE_MinPrice')"
                            :placeholder="this.$t('lbl_EMPBE_FillMinPrice')" v-model="formData.ProductPriceAmount"
                             type="number"
                            :rules="{ max_value: Number(formData.ProductPriceAmountMax),greater_than_0 : true  }"  LimitDecimals="2"
                            :mandatory="$t('lbl_EMPBE_MinMaxPrice')" style="margin-bottom: 0px !important;" />
                    </div>
                    <label class="symbol" v-if="formData.ProductPriceRange">-</label>

                    <div class="flex-item"  v-if="formData.ProductPriceRange">

                        <textbox id="maxPrice" :title="$t('lbl_EMPBE_MaxPrice')"
                            :placeholder="this.$t('lbl_EMPBE_FillMaxPrice')" v-model="formData.ProductPriceAmountMax"
                            type="number"  LimitDecimals="2"
                            :rules="{ between: { min: Number(formData.ProductPriceAmount), max: Number.MAX_VALUE * 2 }, greater_than_0 : true }"
                            :mandatory="$t('lbl_EMPBE_MinMaxPrice')" style="margin-bottom: 0px !important;" />
                    </div>

                    <div>
                        <p class="symbol">/</p>
                    </div>
                    <div class="flex-item">
                        <selection id="PriceUnit" :placeholder="this.$t('lbl_EMPBE_Unit')" :options="this.optionsUnit"
                            v-model="formData.ProductPriceItemUnit" :clearable="true"
                            style="margin-bottom: 0px !important;">
                        </selection>
                    </div>
                </div>
                <div class="BottomCard col-12 " v-if="formData.ProductPriceItemUnit == '99'">
                    <div class="allow d-flex justify-content-end"><img :src="`${this.cdnURL}Polygon.svg`"></div>
                    <div class="cardContent">
                        <div class="other">
                            <div class="cardContent_title cardContent_title_Other">
                                {{ $t('lbl_EMPBE_CompanyInfo_Basic_Other') }}
                            </div>
                            <div>
                                <textbox ControlId="Others" id="otherUnit" :title="$t('lbl_EMPBE_CompanyInfo_Basic_Other_PlaceOther')"
                                    max="40" v-model="formData.ProductPriceItemUnitOther"
                                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_Other_PlaceOther') + $t('lbl_IsRequire')"
                                    style="margin-bottom: 0px !important;">
                                </textbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="checkbox-container">
                    <div class="item">
                        <input class="checkbox" id="DisplayPrice" type="checkbox"
                            v-model="formData.ProductPriceRange"><label class="text-muted" for="DisplayPrice">{{
                                this.$t('lbl_EMPBE_PriceRange') }}</label>
                    </div>

                </div>


            </div>
        </div>
    </div>
</template>

<script>
import { between, max_value, min_value, numeric, required } from 'vee-validate/dist/rules';
import PublicSwitches from './PublicSwitches/PublicSwitches.vue';
import { productService } from '@/_services/product.service';



export default {
    name: 'PricingDisplay',
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            optionsCurrency: [],
            optionsUnit: [],
            currencyUnit: 'USD',
            langId: localStorage.getItem("currentLangId"),
            unit: localStorage.getItem("currentLangId") == 1252 ? 'Piece(s)' : '件',
            cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
            aa:'aa'
        }

    },
    created() {
        this.init();
    },
    computed: {
        formData: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }

    },
    methods: {
        init() {
            productService
                .GetMstKeyValueMapping({ type: "SalesRevenueAmount", langId: this.langId })
                .then((res) => {
                    if (res.isSuccessful) {
                        this.optionsCurrency = [];
                        for (let index = 0; index < res.data.length; index++) {
                            let item = {
                                id: res.data[index].code,
                                label: res.data[index].text,
                            };
                            this.optionsCurrency.push(item);
                        }
                    }

                })
                .catch(error => {
                    console.error('Error:', error);
                });
            productService
                .GetMstKeyValueMapping({ type: "UOM", langId: this.langId })
                .then((res) => {
                    if (res.isSuccessful) {
                        this.optionsUnit = [];
                        for (let index = 0; index < res.data.length; index++) {
                            let item = {
                                id: res.data[index].code,
                                label: res.data[index].text,
                            };
                            this.optionsUnit.push(item);
                        }

                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });

        }
    },
    watch: {

        "formData.ProductPriceCurrUnit": function (val) {
            this.currencyUnit = this.optionsCurrency.find(x => x.id == val)?.label
        },
        "formData.ProductPriceItemUnit": function (val) {
            this.unit = this.optionsUnit.find(x => x.id == val)?.label
        },


    }




};
</script>
<style scoped>
.swithTitle{
color: rgba(0, 0, 0, 0.80); 
font-size: 16px; 
 /* font-family: Inter; */
font-weight: 400; 
line-height: 20.80px; 
word-wrap: break-word;
}
.pricing-display-container {
    display: flex;
    max-width: 804.5px;
    flex-direction: column;
    align-items: flex-start;
    /* gap: 8px; */
    align-self: stretch;
    margin-bottom: 12px;
}

.price-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 0px;
}

.price-range-item {
    display: flex;
    align-items: start;
    flex-direction: row;
}

.flex-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 3px;
    margin-bottom: 10px;
}

.flex-item {
    flex: 1;
}

.symbol {
    margin-top: 6px;
    margin-left: 8px;
    margin-right: 8px;
}


.pricing-display-container .form-group {
    margin-bottom: 0px !important;

}

.price {
    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Microsoft Yahei", Arial, Helvetica, Arial, sans-serif !important;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    /* 33px */
    letter-spacing: 0.15px;
    margin-top:16px;
    margin-bottom:16px;
}

.checkbox-container {
    display: flex;
    padding: 0px;
    flex-direction: column;
    align-items: baseline;
    align-items: flex-start;
}

.checkbox-container .item {
    display: flex;
    padding: 0px 11px 0px 11px;
    justify-content: center;
    align-items: baseline;
}

.checkbox-container .checkbox {
    margin-right: 11px;
}

.BottomCard {
    padding-bottom: 8px;
    position: relative;
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.allow {
    padding-right: 30px;
    margin-bottom: -1px;
}

.cardContent {
    padding: 16px;
    border-radius: 16px;
    background: #F7F7F7;
    margin-bottom: 0px !important;
}

.cardContent_title {
    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.15px;
}

.cardContent_title_Other {
    margin-bottom: 8px;
}
</style>